"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTableModificators = void 0;
const react_1 = require("react");
const useTableModificators = (highlightFlightId, highlightSequenceFlightId) => (0, react_1.useMemo)(() => ({
    row: (row) => {
        const { isActive, id, sequence } = row.original;
        const getHighlightModificator = () => {
            if (highlightFlightId !== undefined && highlightFlightId === id)
                return 'highlight';
            if (highlightSequenceFlightId !== undefined && highlightSequenceFlightId === sequence)
                return 'highlight';
            return undefined;
        };
        return [
            !isActive ? 'not-active' : undefined,
            getHighlightModificator(),
        ];
    },
    column: (column) => ([
        column.disableShowForDevice ? 'device-hidden' : undefined,
        column.isCheckboxColumn ? 'checkbox-cell' : undefined,
        column.isAvailableSeatsColumn ? 'available-seats-cell' : undefined,
    ]),
}), [highlightFlightId, highlightSequenceFlightId]);
exports.useTableModificators = useTableModificators;
//# sourceMappingURL=utils.js.map